import { Injectable, signal } from '@angular/core';
import { PaymentAccount } from '../schemas/payment_account';

@Injectable({
  providedIn: 'root',
})
export class PaymentServices {
  isRecordPayment = signal<boolean>(false);
  isRequestPayment = signal<boolean>(false);
  isWifiQRCode = signal<boolean>(false);

  constructor() {}

  checkPayments(paymentAccount?: PaymentAccount) {}
}
